/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as userService from '../services/userService'
import DepositModel from '../components/sub_components/user/depositeModel'
import CreditRef from './sub_components/user/creditRef'
import WithdrawModel from '../components/sub_components/user/withdrawModel'
import CreditModel from '../components/sub_components/user/creditModel'
import DebitModel from '../components/sub_components/user/debitModel'
import PasswordModel from '../components/sub_components/user/passwordModel'
import StatusModel from '../components/sub_components/user/statusModel'
import LockModel from '../components/sub_components/user/lockModel'
import RGDepositModel from '../components/sub_components/user/rgDepositModel'
import RGWithdrawModel from './sub_components/user/rgWithdrawModel'
import SettlementModel from '../components/sub_components/user/settlementModel'
import UserEventExposure from '../components/sub_components/user/userEventExposure'
import * as apiUserService from '../services/apiUserService'
import Currency from './sub_components/currency'
import { CSVLink } from 'react-csv';
import printJS from 'print-js'
import Autocomplete from 'react-autocomplete';
import { BASE_IMAGE_PATH, BASE_IMAGE_PATH_NEW } from '../configs/api';
import { showChangePasswordBtn, showCasinoControlLink, showClubGames } from '../configs/casinoShowList';
import * as _ from 'lodash'
import * as userUtil from '../util/user.util';
import ClientParentSharingModel from './sub_components/user/clientParentSharingModel';
import { OPERATOR_ID } from '../configs/const';
let userListInterval
let linkClickTimeout
let printClickTimeout
class Affiliates extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         uid: "",
         passcode: "",
         user_id: "",
         user_list: [],
         user_list_search: [],
         rg_user_list: {},
         pageLimit: 25,
         pageActive: 1,
         openPopup: "",
         selectedUser: "",
         currUserData: {},
         emptyClientList: false,
         shortFild: "",
         shortType: "",
         searchText: "",
         showData: false,
         userDownlineList: [],
         userDownlineData: {},
         rgUserDownlineData: {},
         downline_user_id: "",
         select_downline_user_id: "",
         pdf_json: [],
         csv_json: [],
         isOfficeChannel: false,
         isOperator: false,
         allData: false,
         isOnlyClients: false,
         showClientParentSharing: false,
         selectedClientParentSharingUsr: "",
         action: "",
         from: "",
         to: "",
         page_no: 1,
         count_records: 0,
         records_display: 100,
         displayRecordSize: 0,
         loader: false,
         total_page: 1,
         loggedInUser: ''
      };
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "records_display") {
         this.setState({ [name]: value, last_id: "", action: "", first_id: "", page_no: 1 }, () => { this.submitForm() });
      } else {
         this.setState({ [name]: value });
      }
   }
   componentDidMount() {
      this.componentDidMountTask();
   }
   async componentDidMountTask() {
      const { match: { params } } = this.props;
      let tokenData = localStorage.getItem("tokenData")
      tokenData = JSON.parse(tokenData)
      let currUserData = localStorage.getItem("userAccData")
      currUserData = JSON.parse(currUserData)
      this.setState({ currUserData: currUserData, isOfficeChannel: (currUserData.username === 'office' || currUserData.parents.includes('office')), isOperator: currUserData.username === 'operator' })
      const user_id = !!params.user_id ? params.user_id : "";
      const body = this.parseFilterBody(user_id);
      let user_list = await userService.getUsersVsOnlyClientNew(body)
      const action = user_list.action;
      const page_no = user_list.pageNo;
      const count_records = user_list.countRecords;
      user_list = user_list.items
      Array.prototype.forEach.call(user_list, (user, i) => {
         if (user.role === "Client") {
            let avail = user.availableBalance
            avail = avail + user.upLineBalance + user.exposure
            user_list[i].availableBalance = avail
         }
      })

      let rg_users = {};
      // if(rg_user_list.length > 0){
      //    for (let rg_usr of rg_user_list) {
      //       rg_users[rg_usr.username] = rg_usr;
      //    }
      // }

      if (user_list.length > 0) {
         this.setState({ user_id: user_id, user_list: user_list, user_list_search: user_list, action: '', page_no: page_no, count_records: count_records, total_page: Math.ceil(count_records / this.state.records_display), rg_user_list: rg_users, emptyClientList: false, showData: true }, () => {
            // this.shortUser(this.state.shortFild, this.state.shortType)
         })
      } else {
         this.setState({ user_id: user_id, user_list: user_list, user_list_search: user_list, action: '', page_no: page_no, count_records: count_records, total_page: Math.ceil(count_records / this.state.records_display), rg_user_list: rg_users, emptyClientList: true, showData: true }, () => {
            // this.shortUser(this.state.shortFild, this.state.shortType)
         })
      }
      // }
      let self = this
      userListInterval = setInterval(async function userListGet() {
         clearInterval(userListInterval)
         const user_id = !!params.user_id ? params.user_id : "";
         const body = self.parseFilterBody(user_id);
         let user_list = await userService.getUsersVsOnlyClientNew(body);
         const action = user_list.action;
         const page_no = user_list.pageNo;
         const count_records = user_list.countRecords;
         user_list = user_list.items
         !!user_list && Array.prototype.forEach.call(user_list, (user, i) => {
            if (user.role === "Client") {
               let avail = user.availableBalance
               avail = avail + user.upLineBalance + user.exposure
               user_list[i].availableBalance = avail
            }
         })

         let rg_users = {};
         // if(rg_user_list.length > 0){
         //    for (let rg_usr of rg_user_list) {
         //       rg_users[rg_usr.username] = rg_usr;
         //    }
         // }

         self.setState({ user_list: [] }, () => {
            if (user_list.length > 0) {
               self.setState({ user_list: user_list, user_list_search: user_list, action: '', page_no: page_no, count_records: count_records, total_page: Math.ceil(count_records / self.state.records_display), rg_user_list: rg_users, emptyClientList: false, showData: true }, () => {
                  // self.shortUser(self.state.shortFild, self.state.shortType)
               })
            } else {
               self.setState({ user_list: user_list, user_list_search: user_list, action: '', page_no: page_no, count_records: count_records, total_page: Math.ceil(count_records / self.state.records_display), rg_user_list: rg_users, emptyClientList: true, showData: true }, () => {
                  // self.shortUser(self.state.shortFild, self.state.shortType)
               })
            }
            userListInterval = setInterval(userListGet, 10000)
         })
         // }
      }, 10000)
   }

   componentWillUnmount() {
      clearInterval(userListInterval)
      clearTimeout(linkClickTimeout)
      clearTimeout(printClickTimeout)
   }
   shortUser(fild, shortType, reloadData = false) {
      // let userList = this.state.user_list
      // if(!!userList){
      //    userList.sort((a, b) => (a["username"] > b["username"]) ? 1 : ((b["username"] > a["username"]) ? -1 : 0))
      //    if (fild !== "pendingBalance") {
      //       userList.sort((a, b) => (a[fild] > b[fild]) ? 1 : ((b[fild] > a[fild]) ? -1 : 0))
      //    } else {
      //       userList.sort((a, b) => (((!!a.creditRef ? a.creditRef : 0) - (!!a.balance ? a.balance : 0)) > ((!!b.creditRef ? b.creditRef : 0) - (!!b.balance ? b.balance : 0))) ? 1 : ((((!!b.creditRef ? b.creditRef : 0) - (!!b.balance ? b.balance : 0)) > ((!!a.creditRef ? a.creditRef : 0) - (!!a.balance ? a.balance : 0))) ? -1 : 0))
      //    }
      //    if (shortType === "dasc") {
      //       userList = userList.reverse()
      //    }
      //    userList.sort(function (a, b) { return b.isActive - a.isActive });
      // }
      // this.setState({ user_list: [] }, () => {
      //    this.setState({ pageActive: !!pageChange ? 1 : this.state.pageActive, user_list: userList, shortFild: fild, shortType: shortType })
      // })
      this.setState({ shortFild: fild, shortType: shortType }, () => {
         if (reloadData) {
            this.submitForm();
         }
      })
   }
   parseFilterBody(user_id) {
      const body = {
         "sortField": this.state.shortFild,
         "sortType": this.state.shortType === 'asc' ? '1' : '-1',
         "userId": user_id,
         "action": this.state.action,
         "countRecords": this.state.count_records,
         "pageNo": this.state.page_no,
         "recordsPerPage": this.state.records_display
      }
      return body;
   }
   async closeAndUpdate() {
      let tokenData = localStorage.getItem("tokenData")
      tokenData = JSON.parse(tokenData)
      if (!!this.state.downline_user_id) {
         this.setState({ openPopup: '' }, () => {
            this.onSelectedUser(this.state.downline_user_id);
         });
      } else {
         const body = this.parseFilterBody(this.state.user_id);
         let users = await userService.getUsersVsOnlyClientNew(body);
         const action = users.action;
         const page_no = users.pageNo;
         const count_records = users.countRecords;
         users = users.items
         // let rg_user_list = []
         // if(!!tokenData && !!tokenData.sub){
         //    rg_user_list = await userService.getRealGamesChildUsers(tokenData.sub)
         // }

         let rg_users = {};
         // if(rg_user_list.length > 0){
         //    for (let rg_usr of rg_user_list) {
         //       rg_users[rg_usr.username] = rg_usr;
         //    }
         // }

         this.setState({ user_list: [], rg_user_list: {} }, () => {
            this.setState({ user_list: users, action: '', page_no: page_no, count_records: count_records, total_page: Math.ceil(count_records / this.state.records_display), rg_user_list: rg_users, openPopup: "" }, () => {
               // this.shortUser(this.state.shortFild, this.state.shortType)
            })
         })
      }
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }

   async onPDFDownload(user_list_data, allData = false) {
      let pdf_json = []
      if (Object.keys(this.state.userDownlineData).length > 0) {
         pdf_json.push(this.state.userDownlineData)
      } else {
         pdf_json = user_list_data
      }
      this.setState({ pdf_json: [] }, () => {
         this.setState({ pdf_json: pdf_json, allData: allData }, () => {
            printClickTimeout = setTimeout(function () {
               printJS({
                  printable: 'printJS-div',
                  type: 'html',
                  style: '@page { size: Letter landscape;}',
                  targetStyles: ['*']
               })
            }, 500)
         })
      })
   }


   async onDownload(user_list_data, alldata = false) {
      const self = this;
      this.setState({ csv_json: [] }, () => {
         let items = []
         if (Object.keys(this.state.userDownlineData).length > 0) {
            let x = this.state.userDownlineData
            let dictinory = {}
            dictinory["User Name"] = x["username"]
            dictinory["Credit Reference"] = x["creditRef"]
            dictinory["Balance"] = x["balance"]
            dictinory["Pending Bal."] = x["creditRef"] - x["balance"]
            dictinory["Available Bal."] = x["availableBalance"]
            dictinory["Current P&L"] = x["upLineBalance"]
            dictinory["Exposure"] = x["exposure"]
            // dictinory["CG P&L"] = !!this.state.rgUserDownlineData.upLineBalance ? this.state.rgUserDownlineData.upLineBalance : 0.00
            dictinory["U Lock"] = !x["isActive"] ? "True" : "False"
            dictinory["B Lock"] = x["betLock"] ? "True" : "False"
            dictinory["My %"] = x["sharingDetail"]["sports"] + "%"
            dictinory["Type"] = x["role"]
            items.push(dictinory)
         } else {
            // let i = 0

            for (let x of user_list_data) {
               // if ( alldata ? true : (i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)))){ 
               let dictinory = {}
               dictinory["User Name"] = x["username"]
               if (this.state.isOnlyClients) {
                  dictinory["Distributor"] = !!x["parents"] ? userUtil.getAppropriateParent(x["parents"], this.state.currUserData.username) : "-"
               }
               dictinory["Credit Reference"] = x["creditRef"]
               dictinory["Balance"] = x["balance"]
               dictinory["Pending Bal."] = x["creditRef"] - x["balance"]
               dictinory["Available Bal."] = x["availableBalance"]
               dictinory["Current P&L"] = x["upLineBalance"]
               dictinory["Exposure"] = x["exposure"]
               // dictinory["CG P&L"] = !!this.state.rg_user_list[x["username"]] ? this.state.rg_user_list[x["username"]].upLineBalance : 0.00
               dictinory["U Lock"] = !x["isActive"] ? "True" : "False"
               dictinory["B Lock"] = x["betLock"] ? "True" : "False"
               if (!this.state.isOnlyClients) {
                  dictinory["My %"] = x["sharingDetail"]["sports"] + "%"
                  dictinory["Type"] = x["role"]
               }
               items.push(dictinory)
               // }
               // i += 1
            }
         }

         this.setState({ csv_json: items }, () => {
            linkClickTimeout = setTimeout(function () {
               self.csvLink.current.link.click();
            }, 500)
         })
      })
   }

   onSearch(e) {
      let userList = this.state.user_list
      this.setState({ searchText: e.target.value, user_list: [], pageActive: 1 }, () => {
         this.setState({ user_list: userList })
      })
   }

   async onUserSearch(e, name, value) {
      if (value.length > 1) {
         this.setState({ [name]: value })
         let res = await userService.getUserSearch(this.state.currUserData.username, value)
         let lst = []
         for (let x of res.usersList) {
            lst.push({ label: x, value: x, title: x, name: x })
         }
         lst.sort(function (a, b) {
            if (a.value.toLowerCase() < b.value.toLowerCase()) return -1;
            if (a.value.toLowerCase() > b.value.toLowerCase()) return 1;
            return 0;
         });
         this.setState({ userDownlineList: lst })
      }
      else if (value === "") {
         this.setState({ [name]: value, userDownlineList: [], select_downline_user_id: "", userDownlineData: {}, rgUserDownlineData: {} })
      }
      else {
         this.setState({ [name]: value, userDownlineList: [] })
      }
   }

   async onSelectedUser(user_id) {
      let userDetail = await apiUserService.getDashboard(user_id)
      // let rg_userDetail = await userService.getRealGamesUsersByUserName(user_id)

      this.setState({ userDownlineData: {}, rgUserDownlineData: {}, user_id: "" },
         () => {
            this.setState({ userDownlineData: userDetail, rgUserDownlineData: {}, select_downline_user_id: user_id, downline_user_id: user_id })
         }
      )
   }

   async changeActivation(user, isActive) {
      this.setState({ openPopup: "l", action: isActive ? "userUnlock" : "userLock", selectedUser: user })
   }
   async changeBlocking(user, isBlock) {
      this.setState({ openPopup: "l", action: isBlock ? "betLock" : "betUnlock", selectedUser: user })
   }
   onClientDownLine(usr) {
      localStorage.setItem(usr.username, JSON.stringify(usr))
      window.open("/clients/" + usr.username, "_blank")
   }
   sum(array, key) {
      return array.reduce((a, b) => a + (b[key] || 0), 0);
   }
   filterUserData() {
      let userList = this.state.user_list
      const self = this
      if (this.state.searchText !== "" || this.state.searchText !== null || this.state.searchText !== undefined) {
         userList = _.filter(userList, function (obj) {
            return (self.state.isOnlyClients ? (obj['username'].toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1 || (userUtil.getAppropriateParent(obj.parents, self.state.currUserData.username)).toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1) : (obj.username.toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1));
         });
      }
      return Object.assign([], userList)
   }

   onOnlyClientButtonClick() {
      clearInterval(userListInterval);
      this.setState({ isOnlyClients: !this.state.isOnlyClients, searchText: '', downline_user_id: '', select_downline_user_id: "", userDownlineData: {}, user_list: [], user_list_search: [], showData: false, pageActive: 1 }, () => {
         clearInterval(userListInterval);
         this.componentDidMountTask();
      });
   }

   // onAction(e) {
   //    const name = e.target.name;
   //    if (name === "first") {
   //       this.setState({ pageActive: 1 })
   //    } else if (name === "prev") {
   //       this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive - 1) }) ) 
   //    } else if (name === "next") {
   //       this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive + 1) }) )
   //    } else if (name === "last") {
   //       this.setState({ action: name }, this.setState({ pageActive: Math.ceil(this.state.user_list.length / this.state.pageLimit)}) ) 
   //    } 
   // }

   onAction(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "page_no") {
         this.setState({ [name]: parseInt(value), action: "" }, () => { this.submitForm(); });
      }
      if (name === "last") {
         this.setState({ page_no: this.state.total_page, action: "" }, () => { this.submitForm(); });
      }
      else if (name === "prev" || name === "next" || name === "first") {
         this.setState({ action: name }, () => { this.submitForm(); });
      }
   }

   showClientParentSharing(usr) {
      this.setState({ selectedClientParentSharingUsr: usr.username, showClientParentSharing: true });
   }

   hideClientParentSharing() {
      this.setState({ selectedClientParentSharingUsr: "", showClientParentSharing: false });
   }

   async submitForm() {
      const body = this.parseFilterBody(this.state.user_id);
      let user_list = await userService.getUsersVsOnlyClientNew(body)
      const action = user_list.action;
      const page_no = user_list.pageNo;
      const count_records = user_list.countRecords;
      user_list = user_list.items
      Array.prototype.forEach.call(user_list, (user, i) => {
         if (user.role === "Client") {
            let avail = user.availableBalance
            avail = avail + user.upLineBalance + user.exposure
            user_list[i].availableBalance = avail
         }
      })

      let rg_users = {};
      // if(rg_user_list.length > 0){
      //    for (let rg_usr of rg_user_list) {
      //       rg_users[rg_usr.username] = rg_usr;
      //    }
      // }

      if (user_list.length > 0) {
         this.setState({ user_list: user_list, user_list_search: user_list, action: '', page_no: page_no, count_records: count_records, total_page: Math.ceil(count_records / this.state.records_display), rg_user_list: rg_users, emptyClientList: false, showData: true }, () => {
            // this.shortUser(this.state.shortFild, this.state.shortType)
         })
      } else {
         this.setState({ user_list: user_list, user_list_search: user_list, action: '', page_no: page_no, count_records: count_records, total_page: Math.ceil(count_records / this.state.records_display), rg_user_list: rg_users, emptyClientList: true, showData: true }, () => {
            // this.shortUser(this.state.shortFild, this.state.shortType)
         })
      }
   }
   onPagination() {
      let lst = []
      let total_page = this.state.total_page
      for (let x = 1; x <= total_page; x++) {
         if (this.state.page_no === x || Math.abs(x - this.state.page_no) <= 2 || (this.state.page_no < 3 && x < 6) || (total_page - this.state.page_no < 3 && total_page - x < 5)) {
            let htm = <button className={this.state.page_no === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} name="page_no" value={x} onClick={(e) => { this.onAction(e) }}>{x} </button>
            lst.push(htm)
         }
      }
      return lst
   }
   render() {
      let userList = Object.assign([], this.filterUserData())
      let page_no = parseInt(this.state.page_no)
      let count_records = parseInt(this.state.count_records)
      let records_display = parseInt(this.state.records_display)
      let current_record = 0
      let total_record = 0
      let start_record = 0
      if (count_records > (records_display * page_no)) {
         current_record = records_display * page_no
         total_record = count_records
         start_record = current_record - (records_display - 1)
      } else if (!!this.state.user_list && this.state.user_list.length > 0) {
         current_record = count_records
         total_record = count_records
         start_record = ((page_no - 1) * records_display) + 1
      }
      // let pages = []
      // for (let i = 0; i < (Math.ceil(userList.length / this.state.pageLimit)); i++) {
      //    // pages.push(<li className={this.state.pageActive === i + 1 ? "paginate_button page-item active" : "paginate_button page-item"} onClick={() => { this.setState({ pageActive: i + 1 }) }}><a aria-controls="example" data-dt-idx="1" tabIndex="0" className="page-link">{i + 1}</a></li>)
      //    pages.push(<button className={this.state.pageActive === i + 1 ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} key={"unsettle_btn_" + (i + 1)} name="page_no" value={i + 1} onClick={() => { this.setState({ pageActive: i + 1 }) }}>{i + 1} </button>)
      // }
      // let lst = []
      // let total_page = Math.ceil(userList.length / this.state.pageLimit)
      // for (let x = 1; x <= total_page; x++) {
      //    if (this.state.pageActive === x || Math.abs(x - this.state.pageActive) <= 2 || (this.state.pageActive < 3 && x < 6) || (total_page - this.state.pageActive < 3 && total_page - x < 5)) {
      //       let htm = <button className={this.state.pageActive === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} key={"unsettle_btn_" + (x)} name="page_no" value={x} onClick={(e) => {{ this.onAction(e) } this.setState({ pageActive: x })}}>{x} </button>
      //       lst.push(htm)
      //    }
      // }
      // let totalCreditRef = !!this.state.user_list && this.state.user_list.length > 0 ? this.sum(this.state.user_list, "creditRef") : 0
      // let totalBalance = !!this.state.user_list && this.state.user_list.length > 0 ? this.sum(this.state.user_list, "balance") : 0
      // let totalAvailableBalance = !!this.state.user_list && this.state.user_list.length > 0 ? this.sum(this.state.user_list, "availableBalance") : 0
      // let uplineBalance = !!this.state.user_list && this.state.user_list.length > 0 ? this.sum(this.state.user_list, "upLineBalance") : 0
      // let totalExpo = !!this.state.user_list && this.state.user_list.length > 0 ? this.sum(this.state.user_list, "exposure") : 0
      return (
         <div className="bethubs">
            <Header history={this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <div>
                              <h5 className="text-blue  mb-2">
                                 <span>Affiliates List</span>
                                 <div className="row user-header">
                                    <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                                       <div className="d-flex float-left">
                                          <div className="form-group mb-0 d-inline">
                                             <input className="form-control  d-inline-block" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" disabled={!!this.state.select_downline_user_id ? true : false} value={this.state.searchText} />
                                          </div>
                                          {!this.state.isOnlyClients &&
                                             <div className="form-group mb-0 d-inline pl-1">
                                                <div className="form-group font-12 autocomplete-wrapper  d-inline-block mb-1">
                                                   <Autocomplete
                                                      value={this.state.downline_user_id}
                                                      items={this.state.userDownlineList}
                                                      getItemValue={item => item.title}
                                                      renderItem={(item, isHighlighted) =>
                                                         <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                                            {item.title}
                                                         </div>
                                                      }
                                                      inputProps={{ placeholder: 'Search by client' }}
                                                      name="downline_user_id"
                                                      onChange={(event, downline_user_id) => this.onUserSearch(event, "downline_user_id", downline_user_id)}
                                                      onSelect={downline_user_id => this.onSelectedUser(downline_user_id)}
                                                   />
                                                </div>
                                             </div>
                                          }
                                          <CSVLink
                                             data={this.state.csv_json}
                                             filename={"Client List.csv"}
                                             asyncOnClick={true}
                                             className="d-none"
                                             ref={this.csvLink}>
                                          </CSVLink>
                                          <button className="btn btn-sm d-inline csv-icon p-0 pl-1" title="Export Data" onClick={(e) => this.onDownload(userList)} disabled={this.state.user_list.length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon.svg`}></img></button>
                                          <div style={{ display: "none" }}>
                                             <div id="printJS-div">

                                                <table id="exportall" className="table font-12 table-bordered table-sm w-100" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px', width: '100%' }} >
                                                   <thead>
                                                      <tr>
                                                         <th>User Name</th>
                                                         {this.state.isOnlyClients && <th>Distributor</th>}
                                                         <th>Credit Reference</th>
                                                         <th>Balance</th>
                                                         <th>Pending Bal.</th>
                                                         <th>Available Bal.</th>
                                                         <th>Current P&amp;L</th>
                                                         <th>Exposure</th>
                                                         {/* <th>CG P&amp;L</th> */}
                                                         <th>U Lock</th>
                                                         <th>B Lock</th>
                                                         {!this.state.isOnlyClients &&
                                                            <>
                                                               <th>My %</th>
                                                               <th>Type</th>
                                                            </>
                                                         }
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      {this.state.pdf_json.length > 1 ? this.state.pdf_json.map((usr, i) => {
                                                         return (<>
                                                            <tr bgcolor="#ffffff">
                                                               <td title={usr.name}><span className={usr.role === "SuperMaster" || usr.role === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "/aimg/" + usr.role + "-icon.svg"} alt="" /></span><span>{usr.role !== "Client" ? <a className="hand" target='_blank' onClick={() => this.onClientDownLine(usr)} name={usr.username} value={usr.username}>{usr.username}</a> : usr.username}</span></td>
                                                               {
                                                                  this.state.isOnlyClients && <td><span>{!!usr.parents ? userUtil.getAppropriateParent(usr.parents, this.state.currUserData.username) : "-"}</span></td>
                                                               }
                                                               <td><span className="fbold float-right">{!!usr.creditRef ? <Currency key={"creditRef1_" + i} className="fbold" amount={usr.creditRef} showColor={true} /> : "0.00"}</span></td>
                                                               <td><span className="fbold float-right">{!!usr.balance ? <Currency key={"balance1_" + i} className="fbold" amount={usr.balance} showColor={true} /> : "0.00"}</span></td>
                                                               <td><Currency key={"creditRef-balance_" + i} className="fbold float-right" amount={(!!usr.creditRef ? usr.creditRef : 0) - (!!usr.balance ? usr.balance : 0)} showColor={true} /></td>
                                                               <td><span className="fbold float-right">{!!usr.availableBalance ? <Currency key={"availableBalance1_" + i} className="fbold" amount={usr.availableBalance} showColor={true} /> : "0.00"}</span></td>

                                                               <td><span className="fbold float-right" >{!!usr.upLineBalance ? <Currency key={"upLineBalance1_" + i} amount={usr.upLineBalance} showColor={true} /> : "0.00"}</span></td>

                                                               <td><span className="fbold float-right" >{!!usr.exposure ? <Currency key={"userexposure_" + i} amount={usr.exposure} showColor={true} /> : "0.00"}</span></td>
                                                               {/* {!!this.state.rg_user_list[usr.username] ?
                                                               <td><span className="fbold float-right">{!!this.state.rg_user_list[usr.username].upLineBalance ? <Currency key={"RGupLineBalance_" + i} className="fbold" amount={this.state.rg_user_list[usr.username].upLineBalance} showColor={true} /> : "0.00"}</span></td>
                                                            : <td><span className="fbold float-right"> 0.00 </span></td>  
                                                            } */}
                                                               {/* <td><span className="fbold float-right">{!!usr.exposure ? <Currency key={"exposure_"+i} className="fbold" amount={usr.exposure} showColor={true} /> : "0.00"}</span></td> */}
                                                               <td>
                                                                  <span>
                                                                     <label className="checkboxx">
                                                                        <input type="checkbox" checked={!usr.isActive} />
                                                                        <span className="checkmark1"></span>
                                                                     </label>
                                                                  </span>
                                                               </td>
                                                               <td>
                                                                  <span>
                                                                     <label className="checkboxx">
                                                                        <input type="checkbox" checked={usr.betLock} />
                                                                        <span className="checkmark1"></span>
                                                                     </label>
                                                                  </span>
                                                               </td>
                                                               {!this.state.isOnlyClients &&
                                                                  <>
                                                                     <td className="text-right">{!!usr.sharingDetail && <span>{(!!usr.sharingDetail.sports ? usr.sharingDetail.sports : "0") + "% "}</span>}</td>
                                                                     <td><span>{!!usr.role ? usr.role : usr.role}</span></td>
                                                                  </>
                                                               }
                                                            </tr>
                                                         </>
                                                         )
                                                      })
                                                         :
                                                         this.state.pdf_json.length > 0 && this.state.pdf_json.map((usr, i) => {
                                                            return (<>
                                                               <tr bgcolor="#ffffff">
                                                                  <td title={usr.name}><span className={usr.role === "SuperMaster" || usr.role === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "/aimg/" + usr.role + "-icon.svg"} alt="" /></span><span>{usr.role !== "Client" ? <a className="hand" target='_blank' onClick={() => this.onClientDownLine(usr)} name={usr.username} value={usr.username}>{usr.username}</a> : usr.username}</span></td>
                                                                  <td><span className="fbold float-right">{!!usr.creditRef ? <Currency key={"creditRef1_" + i} className="fbold" amount={usr.creditRef} showColor={true} /> : "0.00"}</span></td>
                                                                  <td><span className="fbold float-right">{!!usr.balance ? <Currency key={"balance1_" + i} className="fbold" amount={usr.balance} showColor={true} /> : "0.00"}</span></td>
                                                                  <td><Currency key={"creditRef-balance_" + i} className="fbold float-right" amount={(!!usr.creditRef ? usr.creditRef : 0) - (!!usr.balance ? usr.balance : 0)} showColor={true} /></td>
                                                                  <td><span className="fbold float-right">{!!usr.availableBalance ? <Currency key={"availableBalance1_" + i} className="fbold" amount={usr.availableBalance} showColor={true} /> : "0.00"}</span></td>

                                                                  <td><span className="fbold float-right" >{!!usr.upLineBalance ? <Currency key={"upLineBalance1_" + i} amount={usr.upLineBalance} showColor={true} /> : "0.00"}</span></td>

                                                                  <td><span className="fbold float-right" >{!!usr.exposure ? <Currency key={"userexposure_" + i} amount={usr.exposure} showColor={true} /> : "0.00"}</span></td>
                                                                  {/* <td><span className="fbold float-right" >{!!this.state.rgUserDownlineData.upLineBalance ? <Currency key={"rgupLinepnl1_" + i} amount={this.state.rgUserDownlineData.upLineBalance} showColor={true} /> : "0.00"}</span></td> */}
                                                                  <td>
                                                                     <span>
                                                                        <label className="checkboxx">
                                                                           <input type="checkbox" checked={!usr.isActive} />
                                                                           <span className="checkmark1"></span>
                                                                        </label>
                                                                     </span>
                                                                  </td>
                                                                  <td>
                                                                     <span>
                                                                        <label className="checkboxx">
                                                                           <input type="checkbox" checked={usr.betLock} />
                                                                           <span className="checkmark1"></span>
                                                                        </label>
                                                                     </span>
                                                                  </td>
                                                                  <td className="text-right">{!!usr.sharingDetail && <span>{(!!usr.sharingDetail.sports ? usr.sharingDetail.sports : "0") + "% "}</span>}</td>
                                                                  <td><span>{!!usr.role ? usr.role : usr.role}</span></td>
                                                               </tr>
                                                            </>
                                                            )
                                                         })
                                                      }
                                                   </tbody>
                                                </table>
                                             </div>
                                          </div>
                                          <button className="btn btn-sm pdf-icon d-inline p-0" title="Export Data" onClick={(e) => this.onPDFDownload(userList)} disabled={this.state.user_list.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon.svg`}></img>
                                          </button>
                                          {/* <button className="btn btn-sm d-inline csv-icon-all p-0 mx-2" title="Export All Data" onClick={(e) => this.onDownload(userList, true)} disabled={this.state.user_list.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon-all.svg`}></img>
                                          </button>
                                          <button className="btn btn-sm pdf-icon-all d-inline p-0" title="Export All Data" onClick={(e) => this.onPDFDownload(userList, true)} disabled={this.state.user_list.length > 0 ? false : true}>
                                             <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon-all.svg`}></img>
                                          </button> */}
                                       </div>

                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                       <div className='align-items-center d-flex justify-content-end'>
                                          {Object.keys(this.state.userDownlineData).length === 0 &&
                                             <div className="">
                                                <span className="d-inline search-report"> &nbsp; entries</span>
                                                <div className="form-group font-12 float-right mb-0">
                                                   <select onKeyPress={(e) => this.onAction(e)} onChange={(e) => { this.onChange(e) }} className="form-control" name="records_display" value={this.state.records_display}>
                                                      <option value="100">100</option>
                                                      <option value="200">200</option>
                                                      <option value="500">500</option>
                                                   </select>
                                                </div>
                                                <span className="d-inline search-report mr-2">Show</span>
                                             </div>
                                          }
                                          {this.state.user_id === "" &&
                                             <>
                                                <button className="btn btn-blue " onClick={() => { this.props.history.push("/addAffiliates"); }}>Add Affiliates Account</button>
                                             </>
                                          }
                                       </div>
                                    </div>
                                 </div>
                              </h5>
                           </div>
                           {Object.keys(this.state.userDownlineData).length > 0 ?
                              <div className="row mt-1">
                                 <div className="col-12 col-sm-12 col-md-12 col-lg-12 table-responsive">
                                    <table id="example" className="table table-striped table-bordered table-sm addpadding nowrap" style={{ width: "100%" }}>
                                       <thead>
                                          <tr>
                                             <th>User Name</th>
                                             <th>Email Id</th>
                                             <th>Affiliate code</th>
                                             <th>Sharing %</th>
                                             <th>Is Active</th>
                                             <th>Actions</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr>

                                             <td title={this.state.userDownlineData.name}><span className={this.state.userDownlineData.role === "SuperMaster" || this.state.userDownlineData.role === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "/aimg/" + this.state.userDownlineData.role + "-icon.svg"} alt="" /></span><span>{this.state.userDownlineData.role !== "Client" ? <a className="hand" target='_blank' onClick={() => this.onClientDownLine(this.state.userDownlineData)} name={this.state.userDownlineData.username} value={this.state.userDownlineData.username}>{this.state.userDownlineData.username}</a> : this.state.userDownlineData.username}</span></td>
                                             <td><span className="fbold float-right">{!!this.state.userDownlineData.creditRef ? <Currency key={"creditRef_"} className="fbold" amount={this.state.userDownlineData.creditRef} showColor={true} /> : "0.00"}</span></td>
                                             <td><span className="fbold float-right">{!!this.state.userDownlineData.balance ? <Currency key={"balance_"} className="fbold" amount={this.state.userDownlineData.balance} showColor={true} /> : "0.00"}</span></td>
                                             <td className="text-right">{!!this.state.userDownlineData.sharingDetail && <span>{(!!this.state.userDownlineData.sharingDetail.sports ? this.state.userDownlineData.sharingDetail.sports : "0") + "% "}</span>}</td>
                                             <td>
                                                <span>
                                                   <label className="checkboxx">
                                                      <input type="checkbox" checked={!this.state.userDownlineData.isActive} onChange={() => { this.changeActivation(this.state.userDownlineData, !this.state.userDownlineData.isActive) }} />
                                                      <span className="checkmark1"></span>
                                                   </label>
                                                </span>
                                             </td>
                                             <td>
                                                <div className="mdflex">

                                                   {this.state.userDownlineData.parentId === this.state.currUserData.username &&
                                                      <>
                                                         {this.state.user_id === "" && <span title="Update" className="action-box slast-box text-white" data-toggle="modal" onClick={() => { this.props.history.push("/editclient/" + this.state.userDownlineData.username); }} data-target="#mydeposit">U</span>}
                                                         {/* {this.state.user_id === "" && <span title="Deposit / Credit" className="action-box green-box text-white" data-toggle="modal" onClick={() => { this.setState({ openPopup: "ci", selectedUser: this.state.userDownlineData }) }} data-target="#mycredit">D|C</span>}
                                                         {this.state.user_id === "" && <span title="Withdraw" className="action-box blue-box text-white" data-toggle="modal" onClick={() => { this.setState({ openPopup: "co", selectedUser: this.state.userDownlineData }) }} data-target="#mycredit">W</span>}
                                                         {showChangePasswordBtn && this.state.user_id === "" && <span title="Password Change" className="action-box yellow-box text-black" data-toggle="modal" onClick={() => { this.setState({ openPopup: "p", selectedUser: this.state.userDownlineData }) }} data-target="#mypassword">P</span>} */}
                                                      </>
                                                   }
                                                   {/* <span title="Game Control" className="action-box pink-box text-black" data-toggle="modal" onClick={() => { this.props.history.push("/gamebetlock/" + this.state.userDownlineData.username); }} data-target="#mypassword">GC</span>
                                                   {showCasinoControlLink && <span title="Casino Control" className="action-box floral-box text-black" data-toggle="modal" onClick={() => { this.props.history.push("/casinocontrol/" + this.state.userDownlineData.username); }} data-target="#mypassword">CC</span>}
                                                   {this.state.userDownlineData.parentId === this.state.currUserData.username &&
                                                      <>
                                                         {((showClubGames.onlyInOfficeChnl ? (this.state.isOfficeChannel || this.state.isOperator) : false) || showClubGames.show) && this.state.user_id === "" && <span title="Real Games Debit Real Games Credit" className="action-boxsmall marron-box text-white" data-toggle="modal" data-target="#" onClick={() => { this.setState({ openPopup: "rgd", selectedUser: this.state.userDownlineData }) }}>CGD|C</span>}
                                                         {((showClubGames.onlyInOfficeChnl ? (this.state.isOfficeChannel || this.state.isOperator) : false) || showClubGames.show) && this.state.user_id === "" && <span title="Real Games Withdrawal" className="action-boxsmall orange-box text-black" data-toggle="modal" data-target="#" onClick={() => { this.setState({ openPopup: "rgw", selectedUser: this.state.userDownlineData }) }}>CGW</span>}
                                                      </>
                                                   } */}
                                                </div>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                              :
                              <div className="row mt-1">
                                 <div className="col-12 col-sm-12 col-md-12 col-lg-12 table-responsive">
                                    {!!this.state.showData ? !this.state.emptyClientList ? <table id="example" className="table table-striped table-bordered table-sm addpadding nowrap" style={{ width: "100%" }}>
                                       <thead>
                                          <tr>
                                             <th>
                                                <span>User Name</span>
                                                <span className="d-contant" style={{ float: "right" }}>
                                                   <span onClick={() => { this.shortUser("username", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                   <span onClick={() => { this.shortUser("username", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                </span>
                                             </th>
                                             <th>Email Id</th>
                                             <th>Affiliate code
                                                <span className="d-contant" style={{ float: "right" }}>
                                                   <span onClick={() => { this.shortUser("balance", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                   <span onClick={() => { this.shortUser("balance", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                </span>
                                             </th>
                                             <th>Sharing %</th>
                                             <th>Is Active</th>
                                             <th>Actions</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr>
                                             <td>montuu</td>
                                             <td>mnt@gmail.com</td>
                                             <td>MND@sfdsdf</td>
                                             <td>80%</td>
                                             <td>
                                                <span>
                                                   <label className="checkboxx">
                                                      <input type="checkbox" />
                                                      <span className="checkmark1"></span>
                                                   </label>
                                                </span>
                                             </td>
                                             <td>
                                                <div className="mdflex">
                                                   <span title="Update" className="action-box slast-box text-white" data-toggle="modal">U</span>
                                                   <span title="Password Change" className="action-box yellow-box text-black" >P</span>
                                                </div>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table> :
                                       <span>No Client found under your account.</span>
                                       :
                                       <span>Loading...</span>
                                    }
                                 </div>
                              </div>
                           }
                           {(!!this.state.showData && Object.keys(this.state.userDownlineData).length === 0) && this.state.user_list.length > 0 &&
                              <>
                                 <div className="row">
                                    <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {start_record} - {current_record} of {total_record} entries</span></div>
                                    <div className="col-12 col-sm-12 col-md-6">
                                       <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.page_no === 1 ? true : false}>First</button>
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.page_no === 1 ? true : false}>Prev</button>
                                          {this.onPagination()}
                                          <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.page_no === this.state.total_page ? true : false}>Next</button>
                                          <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.page_no === this.state.total_page ? true : false}>Last</button>
                                       </div>
                                    </div>
                                 </div>
                              </>
                           }
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <Footer />
            {
               <>
                  {this.state.openPopup === 'd' && <DepositModel notify={this.props.notify} user={this.state.selectedUser} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />}
                  {/* {this.state.openPopup === 'w' && <WithdrawModel notify={this.props.notify} user={this.state.selectedUser} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />}
                  {this.state.openPopup === 'c' && <CreditRef notify={this.props.notify} user={this.state.selectedUser} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />} */}
                  {/* {this.state.openPopup === 'ci' && <CreditModel notify={this.props.notify} user={this.state.selectedUser} user_id={this.state.user_id} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />}
                  {this.state.openPopup === 'co' && <DebitModel notify={this.props.notify} user={this.state.selectedUser} user_id={this.state.user_id} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />} */}
                  {this.state.openPopup === 'p' && <PasswordModel notify={this.props.notify} user={this.state.selectedUser} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />}
                  {/* {this.state.openPopup === 's' && <StatusModel notify={this.props.notify} user={this.state.selectedUser} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />}
                  {this.state.openPopup === 'stl' && <SettlementModel notify={this.props.notify} user={this.state.selectedUser} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />}
                  {this.state.openPopup === 'expo' && <UserEventExposure notify={this.props.notify} user={this.state.selectedUser} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />}
                  {this.state.openPopup === 'l' && <LockModel action={this.state.action} notify={this.props.notify} user={this.state.selectedUser} showClubGames={((showClubGames.onlyInOfficeChnl ? (this.state.isOfficeChannel || this.state.isOperator) : false) || showClubGames.show)} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />}
                  {this.state.openPopup === 'rgd' && <RGDepositModel notify={this.props.notify} user={this.state.selectedUser} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />}
                  {this.state.openPopup === 'rgw' && <RGWithdrawModel notify={this.props.notify} user={this.state.selectedUser} closeAndUpdate={() => { this.closeAndUpdate() }} closePopup={() => { this.setState({ "openPopup": "" }) }} />}
                  {this.state.showClientParentSharing && <ClientParentSharingModel notify={this.props.notify} selectedUsername={this.state.selectedClientParentSharingUsr} closePopup={() => { this.hideClientParentSharing() }} />} */}
               </>
            }
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(Affiliates);